var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1167 18.1819C19.7815 16.5505 20.8145 14.2767 20.8145 11.7617C20.8145 6.79757 16.7903 2.77338 11.8262 2.77338C6.86209 2.77338 2.83789 6.79757 2.83789 11.7617C2.83789 16.7258 6.86209 20.75 11.8262 20.75C14.2753 20.75 16.4955 19.7705 18.1167 18.1819ZM18.1167 18.1819L21.1614 21.2266",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.72821d7e84d81feedd8230ae183a6761.svg";
export { ForwardRef as ReactComponent };